<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>{{txtSubmenu}} recibido
            <span *ngIf="isEdit">| {{item.value.code}}</span>
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>)</p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body">
        <form validate [formGroup]="item" (ngSubmit)="onSubmit()" autocomplete="off">
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <div class="form-group col-lg-6">
                  <label>Seleccionar Agencia procedente<span class="required"></span>
                    <ng-container *ngIf="agencySelected != null">
                      <span class="m-l-15 bold"><i class="fas fa-phone m-r-5"></i>{{agencySelected.cellphone}}</span>
                    </ng-container>
                  </label>
                  <ng-container *ngIf="agencySelected != null">
                    <div class="input-group">
                      <input type="text" class="form-control form-control-sm" disabled
                        value="{{agencySelected.tradename}}-{{agencySelected.document_str}}">
                      <div class="input-group-append bg-custom b-0 removeClient">
                        <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                          uib-tooltip="Quitar" (click)="removeAgencies()">
                          <i class="fas fa-backspace w-100 f-s-12"></i>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="agencySelected == null">
                    <component-search-agencies [classSize]="'search-small'"
                      (selectedAgenciesEvent)="selectedAgenciesSearch($event)" class="w-100">
                    </component-search-agencies>
                  </ng-container>
                </div>
                <div class="form-group col-lg-6">
                  <label id="client_label">Responsable de Agencia <span *ngIf="agencySelected != null"
                      class="m-l-5 f-s-8">({{managers.length}} registros)</span></label>
                  <select class="form-control" formControlName="agency_manager_id" id="agency_manager_id">
                    <option [ngValue]="null">Seleccionar opción</option>
                    <option *ngFor="let manager of managers" [value]="manager.id">
                      <span class="f-s-11 m-r-4">{{manager.fullname}}</span> <span class="f-s-10">- (CEL:
                        {{manager.cellphone}})</span>
                    </option>
                  </select>
                </div>
                <div class="form-group col-lg-6">
                  <label id="client_label">Cliente responsable <span class="required"></span>
                    <div class="book__nrodoc m-l-20" *ngIf="isClientSelected">
                      ( {{clientSelected.typeDocument}} : {{clientSelected.document}} )
                    </div>
                  </label>
                  <ng-container *ngIf="isClientSelected">
                    <div class="input-group">
                      <input type="text" class="form-control form-control-sm" disabled
                        value="{{clientSelected.fullname}}">
                      <div class="input-group-append bg-custom b-0 removeClient">
                        <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                          (click)="removeClient()">
                          <i class="fas fa-backspace w-100 f-s-12"></i>
                        </div>
                        <div class="input-group-text bg-info w-100 text-center text-white pointer p-l-10"
                          data-toggle="modal" data-target="#openExtendsClient"
                          (click)="ClientExtendsComponent.editClient(clientSelected.id)">
                          <i class="far fas fa-pen-alt w-100 f-s-12"></i>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="!isClientSelected">
                    <div class="input-group input-group-grid">
                      <component-search-client [classSize]="'search-small'"
                        (selectedClientEvent)="selectedClientSearch($event)" class="w-100">
                      </component-search-client>
                      <div class="input-group-append b-0">
                        <div class="input-group-text w-100 text-center pointer p-l-10" data-toggle="modal"
                          data-target="#openExtendsClient" (click)="ClientExtendsComponent.loadData()">
                          <i class="fas fa-user-plus w-100"></i>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
                <div class="form-group col-lg-4">
                  <label>Número teléfono <span class="required"></span></label>
                  <div class="input-group">
                    <input type="text" class="form-control form-control-sm" id="tel_1" formControlName="tel_1" numeric
                      required placeholder="Tel 1">
                    <div class="input-group-append">
                      <div class="input-group-text p-l-2 p-r-2">-</div>
                    </div>
                    <input type="text" class="form-control form-control-sm" id="tel_2" formControlName="tel_2" numeric
                      placeholder="Tel 2">
                  </div>
                </div>
                <div class="form-group col-lg-2">
                  <label class="m-b-5">N° pax <span class="required"></span></label>
                  <input type="text" class="form-control form-control-sm" id="nro_pax" formControlName="nro_pax"
                    required numeric>
                </div>               
                <div class="form-group col-lg-6">
                  <label><i class="fas fa-plane-arrival m-r-2"></i>Fecha llegada y Hora Llegada<span
                      class="m-l-70"></span>Fecha Salida <i class="fas fa-plane-departure m-l-2"></i></label>
                  <div class="input-group">
                    <input type="text" class="form-control form-control-sm" id="date_arrival"
                      formControlName="date_arrival">
                    <div class="input-group-append">
                      <div class="input-group-text p-l-2 p-r-2">-</div>
                    </div>
                    <div class="input-group-append">
                      <input type="time" class="form-control form-control-sm" formControlName="time_arrival"
                        id="time_arrival">
                    </div>
                    <div class="input-group-append">
                      <div class="input-group-text p-l-2 p-r-2">-</div>
                    </div>
                    <input type="text" class="form-control form-control-sm" id="date_departure"
                      formControlName="date_departure">
                  </div>
                </div>
                <div class="form-group col-lg-6">
                  <label>Llegada por <span class="m-l-130">Ref. datos llegada</span></label>
                  <div class="input-group">
                    <select class="form-control form-control-sm" id="arrivalPlaceSelected"
                      formControlName="arrivalplace_id">
                      <option *ngFor="let item of arrivalplaces" [value]="item.id">{{ item.description }}</option>
                    </select>
                    <div class="input-group-append">
                      <div class="input-group-text p-l-2 p-r-2">-</div>
                    </div>
                    <input type="text" class="form-control form-control-sm" formControlName="arrival_place">
                  </div>
                </div>
                <div class="form-group col-lg-3">
                  <label>N° ref. ó etiqueta</label>
                  <input type="text" class="form-control form-control-sm" formControlName="reference_voucher">
                </div>
                <div class="form-group col-lg-6">
                  <label>Observaciones</label>
                  <textarea formControlName="observations" class="form-control no-resize" rows="2"></textarea>
                </div>
              </div>
            </div>
            <div class="col-lg-12 m-t-10 form__contentTbl">
              <div class="card mb-0">
                <div class="card-header book__accordion__header" id="headingTours">
                  <h5 class="mb-0 mt-0 font-14">
                    <a class="collapsed book__accordion__title" data-parent="#accordion" aria-controls="tours">
                      <i class="fas fa-map-marker-alt m-r-5"></i> Datos tours turístico
                    </a>
                    <div class="flex-30 m-l-10" style="display: inline-flex;">
                      <component-search-tour [classSize]="'search-small'"
                        (selectedTourEvent)="selectedTourSearch($event)" class="w-100"></component-search-tour>
                    </div>
                  </h5>
                </div>
                <div id="tours" class="collapse show" aria-labelledby="headingTours" data-parent="#accordion">
                  <div class="card-body p-l-15 p-r-15 p-t-10">
                    <div class="row">
                      <div class="table-responsive">
                        <table class="table table-hover mb-0 table-sm">
                          <thead class="thead-default">
                            <tr>
                              <th class="text-left w-20">
                                Nombre tours
                              </th>
                              <th class="nowrap text-center w-10">Vehículo</th>
                              <th class="nowrap text-center w-10">Turno</th>
                              <th class="nowrap text-center w-10">N° pax <span class="required-table">*</span></th>
                              <th class="nowrap text-center w-10">Fecha <span class="required-table">*</span></th>
                              <th class="nowrap text-center">Observación</th>
                              <th class="nowrap w-15 text-right">Precio corporativo</th>
                              <th class="nowrap w-15 text-right">Cobranza asignada
                                <i class="fas fa-info-circle m-l-5"
                                  uib-tooltip="Si hay alguna cobranza delegada al operador, importante! en el cuadre de agencias"></i>
                              </th>
                              <th class="nowrap text-center">Realizado</th>
                              <th class="text-center"></th>
                            </tr>
                          </thead>

                          <tbody>
                            <ng-container *ngIf="detail_tours.length == 0">
                              <tr>
                                <td colspan="4"><span>No se encontraron registros</span></td>
                              </tr>
                            </ng-container>
                            <ng-container *ngIf="detail_tours.length > 0">
                              <tr *ngFor="let item of detail_tours; let index_ = index">
                                <td class="text-left w-20">
                                  {{item.description}}
                                  <span *ngIf="item.is_open" class="m-l-5 f-s-9">(Estado abierto)</span>
                                </td>
                                <td class="nowrap text-center w-10 w-xs-20 w-xs-auto">
                                  <select class="form-control sale__inputSelect" id="vehicleTourSelected{{index_}}"
                                    [disabled]="item.is_realized || item.is_paid"
                                    (change)="changeVehicleTour($event.target, index_)">
                                  </select>
                                </td>
                                <td class="nowrap text-center w-10">
                                  <select class="form-control sale__inputSelect" id="shiftTourSelected{{index_}}"
                                    [disabled]="item.is_realized || item.is_paid"
                                    (change)="changeShiftTour($event.target, index_)">
                                  </select>
                                </td>
                                <td class="nowrap text-center w-10">
                                  <input type="text" id="tours_quantity{{index_}}"
                                    class="form-control sale__input text-center" value="{{item.quantity}}"
                                    [disabled]="item.is_realized || item.is_paid"
                                    (keyup)="changeToursQuantity($event.target, index_)" numeric
                                    onclick="click_input(this)">
                                </td>
                                <td class="nowrap text-center w-10">
                                  <input type="text" class="form-control text-center sale__input f-s-12"
                                    id="date_assigned{{index_}}"
                                    [disabled]="item.is_realized || item.is_open || item.is_paid"
                                    value="{{item.date_assigned}}">
                                </td>
                                <td class="nowrap text-center">
                                  <input type="text" id="tours_observation{{index_}}"
                                    class="form-control sale__input f-s-11" value="{{item.observation}}"
                                    [disabled]="item.is_realized || item.is_paid"
                                    (keyup)="changeToursObservation($event.target, index_)">
                                </td>
                                <td class="w-15">
                                  <div class="input-group">
                                    <span class="input-group-prepend"><span class="input-group-text"
                                        style="padding: 2px 9px;">S/</span></span>
                                    <input type="text" id="tours_pricecorporate{{index_}}"
                                      value="{{item.price_corporate}}" numeric decimals="2"
                                      (keyup)="changePriceCorporate($event.target, index_)" onclick="click_input(this)"
                                      class="form-control sale__input text-right" [disabled]="item.is_paid">
                                  </div>
                                </td>
                                <td class="w-15">
                                  <div class="input-group">
                                    <span class="input-group-prepend"><span class="input-group-text"
                                        style="padding: 2px 9px;">S/</span></span>
                                    <input type="text" id="tours_assignedpayment{{index_}}"
                                      value="{{item.assigned_payment}}" numeric decimals="2"
                                      (keyup)="changeAssignedPayment($event.target, index_)" onclick="click_input(this)"
                                      class="form-control sale__input text-right" [disabled]="item.is_paid">
                                  </div>
                                </td>
                                <td class="nowrap text-center">
                                  <span *ngIf="item.date_realized == null">-</span>
                                  <span *ngIf="item.date_realized != null">{{item.date_realized}}</span>
                                </td>
                                <td class="text-center">
                                  <ng-container *ngIf="!item.is_paid">
                                    <i class="far fa-trash-alt book__trash"
                                      *ngIf="isEdit == true && item.is_realized == false"
                                      (click)="removeTour(item.id, index_)"></i>
                                    <i class="far fa-trash-alt book__trash" *ngIf="isEdit == false"
                                      (click)="removeTour(item.id, index_)"></i>
                                  </ng-container>
                                </td>
                              </tr>
                            </ng-container>
                          </tbody>
                        </table>
                      </div>

                      <div class="col-lg-12">
                        <hr style="height: 5px;" class="m-b-0 m-t-20">
                      </div>
                      <div class="form-group col-lg-6 col-12 m-t-10">
                        <label>Ubicación y referencias para recojo del turista <i class="fas fa-info-circle m-l-5"
                            uib-tooltip="Este campo es opcional si es que no se registra información de hotel, para el recojo de los tours del pasajero."></i></label>
                        <textarea rows="2" formControlName="reference_location"
                          class="form-control form-control-sm no-resize"></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card mb-0">
                <div class="card-header book__accordion__header" id="headingHotels">
                  <h5 class="mb-0 mt-0 font-14">
                    <a class="collapsed book__accordion__title" data-parent="#accordion" aria-controls="hotels">
                      <i class="fas fa-bed m-r-5"></i>Registro datos alojamiento
                    </a>
                    <a class="btn btn-sm btn-info m-l-10 f-s-10 bold text-white" id="add_book_hotel"
                      (click)="BookingsHotelExtendsComponent.loadData()" data-toggle="modal"
                      data-target="#openExtendsBookingHotel">Agregar Hotel
                      <i class="fas fa-plus m-l-2"></i>
                    </a>
                  </h5>
                </div>
                <div id="hotels" class="collapse show" aria-labelledby="headingHotels" data-parent="#accordion">
                  <div class="card-body p-l-15 p-r-15 p-t-10">
                    <div class="row">
                      <div class="table-responsive">
                        <table class="table table-hover mb-0 table-sm">
                          <thead class="thead-default">
                            <tr>
                              <th>Nombre Hotel</th>
                              <th>Detalle Hab.</th>
                              <th>S/ Deuda</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <ng-container *ngIf="detail_hotels.length == 0">
                              <tr>
                                <td colspan="4"><span>No se encontraron registros</span></td>
                              </tr>
                            </ng-container>
                            <ng-container *ngIf="detail_hotels.length > 0">
                              <tr *ngFor="let item of detail_hotels; let index_ = index">
                                <td>
                                  <span class="bold">{{item.tradename}}</span> ({{item.citietouristic}})
                                  <p class="m-b-0 f-s-10">Cel: {{item.cellphone}}</p>
                                </td>
                                <td>
                                  <div *ngFor="let bedroom of item.detail_bedrooms">
                                    <p class="m-b-0">{{bedroom.typebedroom}} <span class="f-s-11"> ({{bedroom.quantity}}
                                        hab. x {{bedroom.nights}} noches) </span></p>
                                    <span class="f-s-9 d-block m-b-5" style="font-weight: 600;"><i
                                        class="far fa-calendar-alt m-r-2"></i> {{bedroom.date_checkin}} -
                                      {{bedroom.date_checkout}}
                                      <span class="badge badge-success f-s-8 bold m-l-5" *ngIf="bedroom.is_paid">
                                        Reporte cuadre
                                      </span>
                                    </span>
                                  </div>
                                </td>
                                <td>
                                  <span class="text-danger">{{toolsService.momeySol()}}{{item.total}}</span>
                                </td>
                                <td>
                                  <a class="dropdown-item pointer" style="display: inline;" data-toggle="modal"
                                    data-target="#openExtendsBookingHotel"
                                    (click)="BookingsHotelExtendsComponent.editData(item)">
                                    <i class="far fa-edit m-r-5 text-success"></i>Editar
                                  </a>
                                  <div class="btn-group mo-mb-2">
                                    <button class="btn btn-light btn-dots btn-sm dropdown-toggle" type="button"
                                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                      <i class="fas fa-ellipsis-h"></i>
                                    </button>
                                    <div class="dropdown-menu" x-placement="bottom-start">
                                      <a class="dropdown-item pointer" (click)="removeDetailHotel(index_, item)">
                                        <i class="far fa-trash-alt m-r-5 text-danger"></i>Eliminar
                                      </a>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </ng-container>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <ng-container *ngIf="item.value.total_paid == 0">
              <div class="form-group col-lg-4 col-12">
                <div class="custom-control custom-checkbox float-left">
                  <input type="checkbox" class="custom-control-input" formControlName="is_control_total_received"
                    id="is_control_total_received">
                  <label class="custom-control-label p-t-3" for="is_control_total_received">¿Controlar TOTAL DE RESERVA?</label>
                </div>              
              </div>
            </ng-container>

            <!--summary paid booking-->
            <ng-container *ngIf="item.value.is_control_total_received">
              <div class="card mb-0 book__summary col-12">
                <div class="col-lg-12">
                  <ng-container *ngIf="!isEdit">
                    <div class="row justify-content-md-center">
                      <div class="col-lg-3">
                        <div class="input-group">
                          <span class="input-group-prepend">
                            <span class="input-group-text bold text-primary">TOTAL RESERVA S/</span>
                          </span>
                          <input type="text" class="form-control form-control-sm text-right bold text-primary f-s-14"
                            id="total_tours" onclick="click_input(this)" formControlName="total" numeric decimals="2">
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="isEdit">
                    <div class="row justify-content-md-end">
                      <div class="col-lg-3">
                        <div class="input-group">
                          <span class="input-group-prepend">
                            <span class="input-group-text bold text-primary">T.RESERVA {{toolsService.momeySol()}}</span>
                          </span>
                          <input type="text" class="form-control form-control-sm text-right bold text-primary f-s-14"
                            id="total_tours" onclick="click_input(this)" formControlName="total" numeric decimals="2">
                        </div>
                      </div>
                      <div class="col-lg-3">
                        <div class="input-group">
                          <span class="input-group-prepend">
                            <span class="input-group-text bold f-s-12">PAGADO {{toolsService.momeySol()}}</span>
                          </span>
                          <input type="text" class="form-control form-control-sm text-right bold f-s-14"
                            id="total_paid" numeric decimals="2" disabled value="{{item.value.total_paid}}">
                        </div>
                      </div>
                      <div class="col-lg-3">
                        <div class="input-group">
                          <span class="input-group-prepend">
                            <span class="input-group-text text-danger bold f-s-12">S.PENDIENTE {{toolsService.momeySol()}}</span>
                          </span>
                          <input type="text" class="form-control form-control-sm text-right text-danger bold f-s-14"
                            id="total_paid" numeric decimals="2" disabled value="{{(item.value.total - item.value.total_paid).toFixed(2)}}">
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <div class="text-right m-t-15" *ngIf="isEdit && item.dirty">
                    <span class="badge badge-info">Clic en "Guardar Cambios" para registra los cambios realizados</span>
                  </div>
                </div>
              </div>
            </ng-container>
            

            <div class="form-group col-lg-12 form__footerBtn">
              <div class="text-right">
                <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
                <button type="submit" class="btn btn-primary" [disabled]="item.invalid">
                  <i class="far fa-save m-r-5"></i>
                  <ng-container *ngIf="!isEdit">
                    Guardar Recibido
                  </ng-container>
                  <ng-container *ngIf="isEdit">
                    Guardar Cambios
                  </ng-container>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<app-client-extends (onSubmitEvent)="extendsClient($event)"></app-client-extends>
<app-bookings-hotel-extends (onSubmitEvent)="extendsBookingHotel($event)"></app-bookings-hotel-extends>
